module.exports = __webpack_public_path__ + "img/35.11dddc87.jpg";